export default function () {
    const offset = 285;
    const windowHeightMin = 600;
    const $img = $('.col-image img');
    const windowHeight = window.innerHeight;
    const pictureHeight = $img.height();
    const diff = windowHeight - (pictureHeight + offset);

    if (windowHeight >= windowHeightMin && diff < 0) {
        $img.height(pictureHeight + diff);
        $('.item-picture-element').addClass('responsive');
    }

    // Hide these alerts per default (and only show if needed)
    $('.js-alert').closest('.alert').hide();

    // Listen to click of parent element because the next button is disabled
    $('#next-button[type="submit"]', 'form').parent().on('click', function (event) {
        // If the next button is disabled, show warning that the item must be answered
        const $nextButton = $(this).find('#next-button');
        if ($nextButton.hasClass('disabled')) {
            const $alert = $("#picture-already-skipped-alert");
            $alert.show();
            $alert.closest('.alert').show();
            window.scrollTo(0, 0); // Scroll to top, to make sure alert is visible
            event.preventDefault();
            return false;
        }

        // Set the value of the clicked next button
        const optionValue = $nextButton.data('option-value');
        const $itemInput = $nextButton.closest('form').find('.item-picture-element input[name!="clientTime"]');
        const isOptionValueNumeric = !isNaN(optionValue);
        if (isOptionValueNumeric) {
            $itemInput.val(optionValue);
            // Set client time
            const date = new Date();
            const $clientTimeInput = $nextButton.closest('form').find('.item-picture-element input[name="clientTime"]');
            $clientTimeInput.val(date.getTime());
        } else {
            $itemInput.val(null);
        }
    });
}